export const EquipSlot = {
  // 武器
  MainHead: 1,
  // 玄端
  Clothes: 2,
  // 头冠
  Head: 3,
  // 项链
  Necklace: 4,
  // 护腕
  // Wristband: 5,
  // 护腿
  // Guards: 6,
  // 戒指
  Ring: 7,
  // 绶佩
  Pendant: 8,
  // 绶带
  Belt: 9,
  // 鞜履
  Shoes: 10,
  // 法宝
  WagicWeapon: 11,
};

export const SlotName = {
  [EquipSlot.MainHead]: "武器",
  [EquipSlot.Head]: "头冠",
  [EquipSlot.Clothes]: "玄端",
  [EquipSlot.Belt]: "绶带",
  [EquipSlot.Shoes]: "鞜履",
  // [EquipSlot.Wristband]: "护腕",
  // [EquipSlot.Guards]: "护腿",
  [EquipSlot.WagicWeapon]: "法宝",
  [EquipSlot.Ring]: "戒指",
  [EquipSlot.Necklace]: "项链",
  [EquipSlot.Pendant]: "绶佩",
};



// WEBPACK FOOTER //
// ./src/const/index.js